import React, { Suspense, lazy } from "react";
import { Switch } from "react-router-dom";
import { RoleBasedRouting } from "./permission";

const UserProfile = lazy(() => import("../pages/ProfilesPage/userProfile"));
const TherapistProfile = lazy(() => import("../pages/ProfilesPage/therapistProfile"));
const Setting = lazy(() => import("../pages/SettingsPage/setting"));
const PatientsTherapist = lazy(() => import("../pages/ClinicalRecordsPage/components/patientsEvolution"));
const SessionsTherapist = lazy(() => import("../pages/ProtocolsPage"));
const SessionsStudio = lazy(() => import("../pages/SessionStudioPage/sessionsStudio"));
const Calendar = lazy(() => import("../features/calendar/calendar"));
const CalendarRecomendados = lazy(() => import("../features/calendar/calendar_recomendados"));
const VariablesEvaluations = lazy(() => import("../pages/CategoryEvaluationPage"));
const ViewFlowTeleton = lazy(() => import("../features/teleton/flow.teleton.view"));

// Pages
const Users = lazy(() => import("../pages/UsersPage"));
const Library = lazy(() => import("../pages/LibraryPage"));
const MediaCategories = lazy(() => import("../pages/MediaCategoriesPage"));
const Evaluations = lazy(() => import("../pages/EvaluationsPage"));
const EvaluationsNew = lazy(() => import("../pages/EvaluationsNewPage"));
const PatientEvaluation = lazy(() => import("../pages/PatientEvaluationPage"));
const Subsidiary = lazy(() => import("../pages/SubsidiariesPage"));
const Specialties = lazy(() => import("../pages/SpecialtiesPage"));
const ClinicalData = lazy(() => import("../pages/FollowUpPage"));
const ClinicalDataPatients = lazy(() => import("../pages/FollowUpPage/detail"));
const Metrics = lazy(() => import("../pages/Metrics"));

const SUPERADMIN = "superadmin";
const ADMINCLINIC = "admin-clinic";
const ADMIN = "admin";
const THERAPIST = "therapist";
// const PATIENT = "patient";

const BASIC_PERMISSION = [SUPERADMIN, ADMIN, ADMINCLINIC, THERAPIST];
const ADMIN_PERMISSION = [SUPERADMIN, ADMIN, ADMINCLINIC];
const ADMIN_CLINIC_PERMISSION = [SUPERADMIN, ADMIN, ADMINCLINIC];
const CLINIC_PERMISSION = [SUPERADMIN, ADMINCLINIC, THERAPIST];
// const PATIENT_PERMISSION = [PATIENT];

const SuspenseFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%', fontFamily: 'sans-serif', color: '#666' }}>
    Cargando plataforma...
  </div>
);

const Rutas = () => (
  <Suspense fallback={<SuspenseFallback />}>
    <Switch>
    <RoleBasedRouting
      path="/"
      exact
      component={ClinicalData}
      roles={BASIC_PERMISSION}
      redirect="/treatment/schedule"
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/userProfile"
      exact
      component={UserProfile}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/therapistProfile"
      component={TherapistProfile}
    ></RoleBasedRouting>
    {/* <RoleBasedRouting path="/user" component={User}></RoleBasedRouting> */}
    {/* <RoleBasedRouting path="/chat" component={Chat}></RoleBasedRouting> */}
    <RoleBasedRouting
      path="/content/media-library"
      component={Library}
      roles={ADMIN_CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/content/media-categories"
      component={MediaCategories}
      roles={ADMIN_CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/content/evaluations"
      component={Evaluations}
      roles={ADMIN_CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/clinical_records/evaluations_new"
      component={EvaluationsNew}
      roles={BASIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/clinical_records/patient_evaluations"
      component={PatientEvaluation}
      roles={BASIC_PERMISSION}
    />
    <RoleBasedRouting
      path="/content/evaluation-categories"
      component={VariablesEvaluations}
      roles={ADMIN_CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/setting"
      component={Setting}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/clinicaldata"
      exact
      component={ClinicalData}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/clinicaldata/:id"
      component={ClinicalDataPatients}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/patient-evolution/:id/:event"
      component={PatientsTherapist}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/patient-evolution/:id"
      component={PatientsTherapist}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>

    <RoleBasedRouting
      path="/content/protocols/:protocol/:session"
      component={SessionsTherapist}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/content/protocols"
      component={SessionsTherapist}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/sessionsStudio/:id"
      component={SessionsStudio}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/treatment/planning/:id"
      exact
      component={Calendar}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/treatment/planning"
      exact
      component={Calendar}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/treatment/planning/:user/:data"
      component={CalendarRecomendados}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/resources/subsidiary"
      exact
      component={Subsidiary}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/resources/specialties"
      exact
      component={Specialties}
      roles={CLINIC_PERMISSION}
    ></RoleBasedRouting>

    <RoleBasedRouting
      path="/users"
      component={Users}
      roles={ADMIN_PERMISSION}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/teleton/:id"
      component={ViewFlowTeleton}
    ></RoleBasedRouting>
    <RoleBasedRouting
      path="/metrics"
      component={Metrics}
      roles={ADMIN_PERMISSION}
    ></RoleBasedRouting>
    </Switch>
  </Suspense>
);

export default Rutas;
